"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AlarmOff_exports = {};
__export(AlarmOff_exports, {
  default: () => AlarmOff_default
});
module.exports = __toCommonJS(AlarmOff_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.6367 5.83594C10.3242 5.83594 10.0182 5.86849 9.71875 5.93359C9.41927 5.98568 9.13281 6.05729 8.85938 6.14844L7.74609 5.01562C8.17578 4.80729 8.63151 4.64453 9.11328 4.52734C9.60807 4.41016 10.1159 4.35156 10.6367 4.35156C11.5482 4.35156 12.4076 4.52734 13.2148 4.87891C14.0221 5.23047 14.7253 5.71224 15.3242 6.32422C15.9232 6.92318 16.3984 7.6263 16.75 8.43359C17.0885 9.25391 17.2578 10.1263 17.2578 11.0508C17.2578 11.5716 17.1992 12.0794 17.082 12.5742C16.9648 13.056 16.8021 13.5182 16.5938 13.9609L15.4805 12.8281C15.5716 12.5547 15.6432 12.2682 15.6953 11.9688C15.7604 11.6693 15.793 11.3633 15.793 11.0508C15.793 10.3216 15.6562 9.64453 15.3828 9.01953C15.1094 8.38151 14.7383 7.82812 14.2695 7.35938C13.8138 6.89062 13.2669 6.51953 12.6289 6.24609C12.0039 5.97266 11.3398 5.83594 10.6367 5.83594ZM18 5.62109L17.043 6.77344L13.6641 3.88281L14.6016 2.75L18 5.62109ZM3.9375 3.0625L4.66016 3.80469L17.5312 16.8125L16.5938 17.75L14.9727 16.1094C14.3867 16.6172 13.7227 17.0208 12.9805 17.3203C12.2383 17.6068 11.457 17.75 10.6367 17.75C9.71224 17.75 8.84635 17.5742 8.03906 17.2227C7.23177 16.8711 6.52865 16.3958 5.92969 15.7969C5.33073 15.1849 4.86198 14.4688 4.52344 13.6484C4.17188 12.8411 3.99609 11.9753 3.99609 11.0508C3.99609 10.2435 4.13281 9.46224 4.40625 8.70703C4.69271 7.95182 5.09635 7.26823 5.61719 6.65625L5.03125 6.07031L4.21094 6.77344L3.15625 5.69922L3.97656 5.01562L3 4.01953L3.9375 3.0625ZM13.918 15.0547L6.65234 7.71094C6.28776 8.16667 5.99479 8.68099 5.77344 9.25391C5.5651 9.8138 5.46094 10.4128 5.46094 11.0508C5.46094 11.7669 5.59766 12.444 5.87109 13.082C6.14453 13.707 6.51562 14.2604 6.98438 14.7422C7.45312 15.2109 8 15.582 8.625 15.8555C9.25 16.1289 9.92057 16.2656 10.6367 16.2656C11.2617 16.2656 11.8542 16.1615 12.4141 15.9531C12.974 15.7318 13.4753 15.4323 13.918 15.0547ZM7.6875 3.80469L7.0625 4.33203L6.00781 3.27734L6.65234 2.75L7.6875 3.80469Z",
      fill: "currentColor"
    }
  )
);
const SvgAlarmOff = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AlarmOff_default = SvgAlarmOff;
